import { styled } from '@stitches/react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale'; // Importa el idioma español
import { DownloadIcon } from "@radix-ui/react-icons";

import last from 'lodash/last';
import { isEmpty, isUndefined } from 'lodash';
const MessageContainer = styled('div', {
    display: 'flex',
    width: '100%',
    variants: {
        direction: {
            outgoing: {
                justifyContent: 'flex-end',
            },
            incoming: {
                justifyContent: 'flex-start',
            },
        },
    },
});

const Bubble = styled('div', {
    padding: '8px 12px',
    borderRadius: '12px',
    maxWidth: '65%',
    position: 'relative',
    wordWrap: 'break-word',
    marginTop: '8px',
    marginBottom: '8px',
    variants: {
        direction: {
            outgoing: {
                backgroundColor: '#0090ff',
                color: '#ffffff',
                borderTopRightRadius: '4px',
            },
            incoming: {
                backgroundColor: '#252a2e',
                color: '#ffffff',
                borderTopLeftRadius: '4px',
            },
        },
    },
});

const MessageContent = styled('div', {
    fontSize: '14.2px',
    lineHeight: '1.4',
    color: 'inherit',
});

const AttachmentContainer = styled('button', {
    margin: '1%',
    borderRadius: '4px',
    padding: '4px',
    border: 'none',
});

function MessageBubble({ message }) {
    let messageText = message.payload?.text || message.content,
        messageOptions = message.payload?.options,
        messageDirection = message.direction || (message.type === 'sent' ? 'outgoing' : 'incoming'),
        messageCreatedAt = message.createdAt,
        type = message?.type;

    if (type === "text" && isUndefined(messageText))
        return;

    if (messageText && messageText.toUpperCase().includes("(AUDIO)"))
        type = "audio";

    if (messageCreatedAt)
        messageCreatedAt = format(new Date(messageCreatedAt), 'HH:mm', { locale: es });

    function downloadBase64File() {
        const link = document.createElement('a'),
            data = message.payload;

        link.href = `data:${data.mimeType};base64,${data.base64Data}`;
        link.download = data.filename;
        link.click();
    }

    return (
        <MessageContainer direction={messageDirection}>
            <Bubble direction={messageDirection} style={{ position: 'relative' }}>
                <div>
                    {(() => {
                        switch (type) {
                            case 'text':
                                if (messageText.includes("�")) {
                                    return <MessageContent>{messageText.split("�").length > 1 ? last(messageText.split("�")) : messageText}</MessageContent>
                                } else {
                                    return <MessageContent>{messageText}</MessageContent>
                                };
                            case 'audio':
                                return (
                                    message.payload?.audioUrl && (
                                        <audio controls style={{ maxWidth: '300px', paddingTop: '5px' }}>
                                            <source src={`data:audio/mpeg;base64,${message.payload.base64Data}`} type="audio/mpeg" />
                                            Tu navegador no soporta el elemento de audio.
                                        </audio>
                                    )
                                );
                            case 'image':
                                return (
                                    message.payload?.imageUrl && (
                                        <img src={`data:image/png/jpeg;base64,${message.payload.base64Data}`} alt={message.payload.fileName} style={{ maxWidth: '300px', borderRadius: '8px' }} />
                                    )
                                );
                            case 'video':
                                return (
                                    message.payload?.videoUrl && (
                                        <video controls width="600" style={{ maxWidth: '300px', borderRadius: '8px' }}>
                                            <source src={`data:video/mp4;base64,${message.payload.base64Data}`} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    )
                                );
                            case 'file':
                                return (
                                    message.payload?.fileUrl && (
                                        <button onClick={downloadBase64File} style={{ margin: '5% 0', display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                            <span>{message.payload.filename}</span>
                                            <DownloadIcon width={20} height={20} style={{ marginLeft: '10px' }} />
                                        </button>
                                    )
                                );
                            default:
                                return (
                                    <MessageContent>{messageText.split("�").length > 1 ? last(messageText.split("�")) : messageText}</MessageContent>
                                );
                        }
                    })()}

                    <div style={{ textAlign: 'right', fontSize: '12px', color: '#fff' }}>
                        {messageCreatedAt}
                    </div>
                </div>

                {(messageOptions) ?
                    messageOptions.map((option, index) => (
                        <AttachmentContainer key={index}>
                            <MessageContent>{option.label}</MessageContent>
                        </AttachmentContainer>
                    )) :
                    null
                }
            </Bubble>
        </MessageContainer>
    );
}

export default MessageBubble;